var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPdWind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#3385F8",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M12 5a.695.695 0 0 0-.636.385h-.002s-1.3 2.72-1.42 5.51A2.86 2.86 0 0 1 12 10.039a2.86 2.86 0 0 1 2.059.856c-.12-2.79-1.421-5.51-1.421-5.51h-.003A.694.694 0 0 0 12 5zm-2.431 6.579c-2.539 1.54-4.434 4.008-4.434 4.008l.001.002a.634.634 0 0 0-.136.392.664.664 0 0 0 .76.645v.002s3.172-.342 5.828-1.686c-.733-.144-1.403-.567-1.807-1.239a2.498 2.498 0 0 1-.212-2.124zm4.861 0a2.495 2.495 0 0 1-.211 2.124c-.404.672-1.074 1.095-1.807 1.24 2.656 1.343 5.826 1.685 5.826 1.685l.001-.003a.664.664 0 0 0 .76-.644.634.634 0 0 0-.137-.392l.002-.002s-1.895-2.469-4.434-4.008zm-2.441 4.21a.709.709 0 0 0-.71.709l-.514 3.493h1.114a.743.743 0 0 0 .235 0h1.121l-.515-3.493a.688.688 0 0 0-.211-.504.732.732 0 0 0-.52-.204z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdWind);
export default __webpack_public_path__ + "static/media/icon-pd-wind.453e6b3d7aa8708ff1247212ec034604.svg";
export { ForwardRef as ReactComponent };